import { useQuery } from "@tanstack/react-query"
import { fetchTags, searchSubscribers } from "sdk/command-palette"

export const commandPaletteKeys = {
  all: ["command-palette"],
  subscriberSearch: query => [...commandPaletteKeys.all, "subscribers", query],
  tags: () => [...commandPaletteKeys.all, "tags"]
}

export function useSearchSubscribers({ params, ...queryConfig }) {
  return useQuery({
    queryKey: commandPaletteKeys.subscriberSearch(params.query),
    queryFn: () => searchSubscribers(params),
    ...queryConfig
  })
}

export function useTags(queryConfig = {}) {
  return useQuery({
    queryKey: commandPaletteKeys.tags(),
    queryFn: fetchTags,
    // The tag list changes rarely; cache it so reopening the subpage within a
    // session doesn't refetch the whole list.
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryConfig
  })
}
